const normalizeSlug = (slug = "") => {
  return String(slug)
    .trim()
    .replace(/\/+/g, "/")
    .replace(/^\/|\/$/g, "");
};

/**
 * Create product PDP URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getProductUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}`;
};

/**
 * Create product Listing URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getlistingUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/${cleanSlug}`; 
};